/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export function getMetaData(name: string): string {
  const metaCollection = document.getElementsByTagName('meta');
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < metaCollection.length; i++) {
    if (metaCollection[i].name === name) {
      return metaCollection[i].content;
    }
  }
  return undefined;
}
